import { FetchContext } from '../fetch-context';
import { QuestionnaireProgress } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getQuestionnaireProgress: (
  fetchContext: FetchContext,
  questionnaireId: number,
  accessToken?: string,
) => Promise<QuestionnaireProgress> = (fetchContext, questionnaireId, accessToken) => fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/progress`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<QuestionnaireProgress>(fetchContext.errorStore, response, 'get questionnaire progress'));
